<template>

       <div class="page-header">
        <div class="row justify-content-end">
          <div class="col">
            <h2 class="page-title">{{$t('entry.confirmText')}}</h2>
          </div>
        </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="card-body">
            <div class="card-content">
              <div class="row termcondition-font">
              <p class="para condition-height alert alert-info">
          {{instructions.startUpPara}} 
      </p>
            <strong class="p-bot">
          <p>{{$t('candidateProfile.agreement.lblUndertakes')}}</p>
      </strong>
                <ul class="">
                  <li v-for="item in instructions.instructionList">{{item.instructionMsg}}
                    <ul class="subInstructionFont" v-if="item.subInstructions">
                      <li v-for="subItem in item.subInstructions">{{subItem.instructionMsg}} </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="text-center pt-3">
                <button class="btn btn-info-alt" @click ="$router.push('entry')">{{$t('button.back')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
axios.default.baseURL = ''
export default {
  name: 'Entry',
  data () {
    return {
      instructions: {}
    }
  },
  mounted () {
    this.getTermCondition()
  },
  methods: {
    getTermCondition () {
      axios.get('r/getGeneralInstructions/' + 'TermCondition')
      .then(responses => {
        if (responses.status === 200) {
          this.instructions = responses.data
        }
      })
      .catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style lang="scss">
.termcondition-font{
  font-size: 14px;
}
.condition-height{
  line-height: 1.9;
}
</style>



// WEBPACK FOOTER //
// src/components/registration/termsConditions.vue